import { render, staticRenderFns } from "./AppSectionTitle.vue?vue&type=template&id=3aec61b5&scoped=true"
import script from "./AppSectionTitle.vue?vue&type=script&lang=js"
export * from "./AppSectionTitle.vue?vue&type=script&lang=js"
import style0 from "./AppSectionTitle.vue?vue&type=style&index=0&id=3aec61b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aec61b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
